"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeToNodes = void 0;
const graphql_zeus_1 = require("graphql-zeus");
const graphsource_1 = require("graphsource");
class TreeToNodes {
    static compareData(d1, d2) {
        if (!d1 && d2) {
            return false;
        }
        if (d1 && !d2) {
            return false;
        }
        if (!d1 && !d2) {
            return true;
        }
        return d1.type === d2.type;
    }
    static createExtendHelper(f) {
        return {
            args: [f],
            data: {
                type: graphql_zeus_1.Helpers.Extend,
            },
            name: graphql_zeus_1.Helpers.Extend,
            type: {
                name: graphql_zeus_1.Helpers.Extend,
            },
        };
    }
    static resolveField(root, nodes, rootNode) {
        const nodeCreated = graphsource_1.NodeUtils.createBasicNode({ x: 0, y: 0 }, {
            name: root.data.type === graphql_zeus_1.Value.NullValue ? 'null' : root.name,
            type: root.type.name,
            description: root.description,
            options: root.type.options || root.type.directiveOptions || root.type.operations || [],
        });
        nodes.push(nodeCreated);
        if (rootNode) {
            rootNode.inputs.push(nodeCreated.id);
            nodeCreated.outputs.push(rootNode.id);
        }
        return nodeCreated;
    }
    static resolveTree(tree) {
        const nodes = [];
        const resolveAllFields = (parserFields) => {
            const rootNodes = parserFields.map(({ parserField, node }) => {
                return {
                    parserField,
                    node: TreeToNodes.resolveField(parserField, nodes, node),
                };
            });
            rootNodes
                .filter((pf) => pf.parserField.interfaces && pf.parserField.interfaces.length)
                .forEach((f) => {
                TreeToNodes.createInterfaces(f.parserField.interfaces, f.node, nodes);
            });
            const returnRootNodes = rootNodes
                .filter((rn) => rn.parserField.args && rn.parserField.args.length)
                .map((rn) => rn.parserField.args.map((a) => ({
                parserField: a,
                node: rn.node,
            })))
                .reduce((a, b) => [...a, ...b], []);
            if (returnRootNodes.length > 0) {
                resolveAllFields(returnRootNodes);
            }
            const returnDirectives = rootNodes
                .filter((rn) => rn.parserField.directives && rn.parserField.directives.length)
                .map((rn) => {
                const directiveHelper = TreeToNodes.createDirectivesHelper(rn.node, nodes);
                return rn.parserField.directives.map((a) => ({
                    parserField: a,
                    node: directiveHelper,
                }));
            })
                .reduce((a, b) => [...a, ...b], []);
            if (returnDirectives.length > 0) {
                resolveAllFields(returnDirectives);
            }
            return;
        };
        resolveAllFields(tree.nodes
            .map((parserField) => parserField.data.type in graphql_zeus_1.TypeExtension ? TreeToNodes.createExtendHelper(parserField) : parserField)
            .map((parserField) => ({
            parserField,
        })));
        return { nodes };
    }
}
exports.TreeToNodes = TreeToNodes;
TreeToNodes.connectAndCreate = (n, rootNode, nodes) => {
    const createdNode = TreeToNodes.resolveField(n, nodes);
    rootNode.inputs.push(createdNode.id);
    createdNode.outputs.push(rootNode.id);
    nodes.push(createdNode);
    return createdNode;
};
TreeToNodes.createInterfaces = (interfaces, rootNode, nodes) => {
    const createdNode = TreeToNodes.connectAndCreate({
        name: graphql_zeus_1.Helpers.Implements,
        data: {
            type: graphql_zeus_1.Helpers.Implements,
        },
        type: {
            name: graphql_zeus_1.Helpers.Implements,
        },
    }, rootNode, nodes);
    interfaces.forEach((i) => {
        TreeToNodes.connectAndCreate({
            type: {
                name: i,
            },
            name: i,
            data: {
                type: graphql_zeus_1.Instances.Implement,
            },
        }, createdNode, nodes);
    });
};
TreeToNodes.createDirectivesHelper = (rootNode, nodes) => {
    return TreeToNodes.connectAndCreate({
        name: graphql_zeus_1.Helpers.Directives,
        data: {
            type: graphql_zeus_1.Helpers.Directives,
        },
        type: {
            name: graphql_zeus_1.Helpers.Directives,
        },
    }, rootNode, nodes);
};
